import React from 'react';
import { Link } from 'react-router-dom';

const offers = [
  {
    k: '01 · Web',
    title: 'Websites',
    body: 'From a five-page starter site to a full online store or a custom platform with logins and dashboards. Mobile-friendly, fast, and editable by you.',
    from: 'From $1,800',
    time: '2–14 weeks',
    to: '/pricing#web',
  },
  {
    k: '02 · Mobile',
    title: 'Mobile apps',
    body: 'iOS and Android from one codebase. We handle the developer accounts, store submissions, and the review process — the part that trips most people up.',
    from: 'From $14,000',
    time: '8+ weeks',
    to: '/pricing#mobile',
  },
  {
    k: '03 · Bundles',
    title: 'Web + mobile together',
    body: 'One design system, one backend, one set of customer accounts. Doing both at once saves 12–18% over doing them a year apart.',
    from: 'From $16,500',
    time: 'Save ~15%',
    to: '/pricing#bundles',
  },
  {
    k: '04 · AI',
    title: 'AI integration',
    body: 'Chatbots trained on your business, assistants that answer from your documents, and workflow automation. Added to our builds or bolted onto what you have.',
    from: 'From $1,800',
    time: '2–10 weeks',
    to: '/pricing#ai',
  },
];

export const Services = () => (
  <div className="wrap">
    <section id="work">
      <div className="sec-head">
        <h2>What we build</h2>
        <span className="sec-tag">Four things, done well</span>
      </div>
      <p className="sec-sub">
        Every project is scoped up front and quoted as a fixed fee — the full
        price list is public on our rate card.
      </p>
      <div className="offer-grid">
        {offers.map((o) => (
          <Link key={o.title} to={o.to} className="offer">
            <span className="k">{o.k}</span>
            <h3>{o.title}</h3>
            <p>{o.body}</p>
            <span className="from">
              {o.from} <small>· {o.time}</small> <span className="go">→</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  </div>
);
